<template>
  <div>
    <Batch title="个人奖申报批次" @handleNext="handleNext" />
  </div>
</template>

<script>
import Batch from '@/components/batch/Batch'
export default {
  components: { Batch },
  data () {
    return {}
  },
  created () {},
  methods: {
    handleNext(e) {
      this.$router.push({ path: '/personal', query: { batchId: e.id } })
    }
  }
}
</script>
